import PropTypes from "prop-types";

import { useState } from "react";

import Card from "react-bootstrap/Card";

import {
  WORKSPACE_TYPE_PRIVATE,
  WORKSPACE_TYPE_PUBLIC,
  GROUP_OF_TILES_BY_AWAITING_ID,
  TILE_TYPE_GROUP_OF_TILES,
} from "../../constants/stringConstants";

import DesignedLabel from "../DesignedLabel";

import { useTranslation } from "react-i18next";

import iconsEdit from "../../assets/svg/icons-edit.svg";

import iconsDelete from "../../assets/svg/icons-delete.svg";

import iconsBack from "../../assets/svg/icons-back.svg";

import CustomModal from "../CustomModal";

import { deleteTile, updateTile } from "../../actions/tileActions";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import FieldsInForm from "../../utils/FieldsInForm";

import { formatDate } from "../formatDate";

import { useHistory } from "react-router-dom";

const CardGroupOfTilesCustom = ({
  card,
  userEmail,
  singleTopic,
  userToken,
  deleteTile,
  updateTile,
  currentWorkspace,
  id,
  fromDocumentContainer,
  fromCardAssessmentContainer,
  singleTile,
  tileTypes,
}) => {
  const { t } = useTranslation();
  const [isDeletedDialogOpened, setIsDeletedDialogOpened] = useState(false);
  const [isEditDialogOpened, setIsEditDialogOpened] = useState(false);
  const [tile_value, setTileValue] = useState(card.TILE_VALUE);
  const [tile_audience, setTileAudience] = useState(card.TILE_AUDIENCE);
  const [tile_name, setTileName] = useState(card.TILE_NAME);
  const [submitOccurred, setSubmitOccurred] = useState(false);
  const argsForEditTextTileDialog = {
    findFormErrors: () => {
      const newErrors = {};

      if (!tile_name || tile_name === "")
        newErrors.TILE_NAME = t("tileNameIsMandatory");
      else if (tile_name.length > 255)
        newErrors.TILE_NAME = t("tileNameCantBeLongerThan255Charachteres");

      return newErrors;
    },
    fieldsForEditTextTile: [
      {
        name: "TILE_NAME",
        type: "text",
        className: "register-login-text-field",
        required: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("nameTheTile"),
        placeholder: t("egIdentifiedRisks"),
        onChangeText: (value) => setTileName(value),
        value: tile_name,
      },
      {
        name: "TILE_AUDIENCE",
        type: "select",
        className: "register-login-text-field",
        options: [
          {
            description: t("privateWorkspace"),
            value: WORKSPACE_TYPE_PRIVATE,
          },
          { description: t("publicWorkspace"), value: WORKSPACE_TYPE_PUBLIC },
        ],
        required: true,
        disabled: currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE,
        displayProperty: "description",
        valueProperty: "value",
        label: t("tileAudience"),
        onChange: (value) => setTileAudience(value),
        value: tile_audience,
      },
    ],
    onSubmit: () => {
      setIsEditDialogOpened(false);
      // updateTile(
      //   userToken,
      //   card.TILE_ID,
      //   tile_name,
      //   tile_value,
      //   tile_audience,
      //   card.TILE_TYPE,
      //   fromDocumentContainer
      //     ? id
      //     : fromCardAssessmentContainer
      //     ? singleTile.TILE_ID
      //     : singleTopic.TOPIC_ID,
      //   fromCardAssessmentContainer ? TILE_TYPE_GROUP_OF_TILES : undefined
      // );
      updateTile({
        usertoken: userToken,
        tile_id: card.TILE_ID,
        tile_name: tile_name,
        tile_value: tile_value,
        tile_audience: tile_audience,
        tile_type: card.TILE_TYPE,
        topic_id: fromDocumentContainer
          ? id
          : fromCardAssessmentContainer
          ? singleTile.TILE_ID
          : singleTopic.TOPIC_ID,
        tile_types: fromCardAssessmentContainer
          ? TILE_TYPE_GROUP_OF_TILES
          : undefined,
      });
    },
  };
  const history = useHistory();

  const matchingObjects = tileTypes.filter(
    (obj) => obj.TILE_TYPE_NAME === card.TILE_TYPE
  );

  return (
    <>
      <Card
        className={
          card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE
            ? "card-tile card-tile-text card-group-of-tiles cursor-pointer"
            : "card-tile card-tile-private card-tile-text card-group-of-tiles cursor-pointer"
        }
      >
        <Card.Header
          onClick={() =>
            history.push(GROUP_OF_TILES_BY_AWAITING_ID + card.TILE_ID, {
              from: "the_app",
            })
          }
        >
          <div className="cardHeaderWrapper">
            {matchingObjects &&
              matchingObjects.map((item) => (
                <img
                  key={item.TILE_NAME}
                  width={30}
                  height={30}
                  src={item.TILE_TYPE_ICON_PATH}
                  alt={item.TILE_NAME}
                />
              ))}
            <span className="tile-name"> {card.TILE_NAME}</span>
          </div>
          <DesignedLabel
            label={WORKSPACE_TYPE_PRIVATE.toUpperCase()}
            classNameLabel={
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                ? "private-label"
                : "display-none"
            }
          />
          <DesignedLabel
            label={t("partnerContent").toUpperCase()}
            classNameLabel={
              (card.PARTNER === "TRUE" || card.PARTNER === true) &&
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PUBLIC
                ? "partner-content-label"
                : "display-none"
            }
          />
        </Card.Header>
        <Card.Body
          className="tile-body"
          onClick={() =>
            history.push(GROUP_OF_TILES_BY_AWAITING_ID + card.TILE_ID, {
              from: "the_app",
            })
          }
        >
          <Card.Title
            className={
              card.TILE_AUDIENCE !== WORKSPACE_TYPE_PRIVATE &&
              card.CREATED_BY !== userEmail
                ? "tile-created-by"
                : "tile-created-by visibility-hidden"
            }
          >
            {t("createdBy") + ": "}
            <img
              width={24}
              height={24}
              src={card.CREATOR_LOGO}
              className={
                card.CREATOR_LOGO ? "created-by-logo-tile" : "display-none"
              }
            />
            {card.CREATED_BY}
          </Card.Title>
          {/* Here */}
          <Card.Text className="tile-text cursor-pointer">
            <span className="group-of-tiles-option">{t("groupOfTiles")}</span>
            <img
              width={24}
              height={24}
              className="group-of-tiles-icon"
              src={iconsBack}
            />
          </Card.Text>
        </Card.Body>
        <Card.Footer className="tile-footer">
          <Card.Text className="tile-last-updated">
            {t("lastUpdated") +
              ": " +
              formatDate(new Date(card.TILE_LAST_UPDATE), "dd.mm.yyyy")}
          </Card.Text>
          <Card.Text
            className={
              card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE ||
              card.CREATED_BY === userEmail
                ? "tile-edit-or-updated"
                : "display-none"
            }
          >
            <span
              onClick={() => setIsEditDialogOpened(true)}
              className="card-topic-group-footer-option"
            >
              <img
                width={24}
                height={24}
                src={iconsEdit}
                className="card-topic-group-footer-img"
              />
              {t("edit")}
            </span>
            <span
              className="card-topic-group-footer-option"
              onClick={() => setIsDeletedDialogOpened(true)}
            >
              <img
                width={24}
                height={24}
                src={iconsDelete}
                className="card-topic-group-footer-img"
              />
              {t("delete")}
            </span>
          </Card.Text>
        </Card.Footer>
      </Card>
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("deleteATile")}
        setIsShown={setIsDeletedDialogOpened}
        isShown={isDeletedDialogOpened}
        negativeAction={() => setIsDeletedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToDeleteATile")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToDeleteATile")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("deleteATile")}
        positiveAction={() =>
          deleteTile(
            userToken,
            card.TILE_ID,
            fromDocumentContainer
              ? id
              : fromCardAssessmentContainer
              ? singleTile.TILE_ID
              : singleTopic.TOPIC_ID,
            fromCardAssessmentContainer ? TILE_TYPE_GROUP_OF_TILES : undefined
          )
        }
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal edit-tile-modal edit-text-tile"
        titleOfModal={t("editTile")}
        setIsShown={setIsEditDialogOpened}
        isShown={isEditDialogOpened}
        negativeAction={() => {
          setIsEditDialogOpened(false);
          setTileValue(card.TILE_VALUE);
        }}
        content={
          <>
            <div className="tile-information">
              <span className="tile-name fs-28">{card.TILE_NAME}</span>
              <span className="tile-audience-type fs-16">
                {card.TILE_AUDIENCE === WORKSPACE_TYPE_PRIVATE
                  ? t("privateTile") + " | " + card.TILE_TYPE
                  : t("publicTile") + " | " + card.TILE_TYPE}
              </span>
            </div>
            <FieldsInForm
              fields={argsForEditTextTileDialog.fieldsForEditTextTile}
              findFormErrors={argsForEditTextTileDialog.findFormErrors}
              submitOccurred={submitOccurred}
              setSubmitOccurred={setSubmitOccurred}
              onSubmit={argsForEditTextTileDialog.onSubmit}
            />
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("saveEdits")}
        positiveAction={() => setSubmitOccurred(true)}
        isBackdrop="static"
        isCentered={true}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    singleTile: state.tileReducer.singleTile,
    tileTypes: state.tileReducer.tileTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteTile: bindActionCreators(deleteTile, dispatch),
    updateTile: bindActionCreators(updateTile, dispatch),
  };
};

CardGroupOfTilesCustom.propTypes = {
  card: PropTypes.shape({
    CREATED_BY: PropTypes.string,
    TILE_AUDIENCE: PropTypes.string,
    TILE_ICON_PATH: PropTypes.string,
    TILE_ID: PropTypes.number,
    TILE_LAST_UPDATE: PropTypes.string,
    TILE_NAME: PropTypes.string,
    TILE_STATUS: PropTypes.string,
    TILE_TYPE: PropTypes.string,
    TILE_VALUE: PropTypes.string,
    CREATOR_LOGO: PropTypes.string,
    PARTNER: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }).isRequired,
  userEmail: PropTypes.string.isRequired,
  singleTopic: PropTypes.shape({
    TOPIC_ID: PropTypes.number,
  }),
  userToken: PropTypes.string.isRequired,
  deleteTile: PropTypes.func.isRequired,
  updateTile: PropTypes.func.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fromDocumentContainer: PropTypes.bool,
  fromCardAssessmentContainer: PropTypes.bool,
  singleTile: PropTypes.shape({
    TILE_ID: PropTypes.number,
  }).isRequired,
  tileTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

CardGroupOfTilesCustom.defaultProps = {
  card: {
    CREATED_BY: "",
    TILE_AUDIENCE: "",
    TILE_ICON_PATH: "",
    TILE_ID: 0,
    TILE_LAST_UPDATE: "",
    TILE_NAME: "",
    TILE_STATUS: "",
    TILE_TYPE: "",
    TILE_VALUE: "",
    CREATOR_LOGO: "",
  },
  userEmail: "",
  singleTopic: {},
  userToken: "",
  deleteTile: () => {},
  updateTile: () => {},
  currentWorkspace: {},
  id: "",
  fromDocumentContainer: false,
  fromCardAssessmentContainer: false,
  singleTile: {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardGroupOfTilesCustom);
